module.exports = __webpack_public_path__ + "img/unp-branco.000eeead.svg";